import { ComponentStyleConfig } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

export const NumberInput: ComponentStyleConfig = {
  baseStyle: (props) => ({
    field: {
      bg: "rgba(252, 252, 253, 0.025)",
      border: "1px solid",
      borderRadius: "8px",
      borderColor: mode("blue.200", "#E6E8EC")(props),
      // borderColor: "blue.200",
      _disabled: {
        bg: "#2C2C2C",
        cursor: "not-allowed",
      },
      _invalid: {
        borderColor: "error",
      },
      _focus: {
        bg: "rgba(252, 252, 253, 0.05)",
        borderColor: "blue.300!important",
      },
      minH: "fit-content",
      height: "auto",
      p: "3",
      lineHeight: "1.2em",
    },
  }),
  // * https://github.com/chakra-ui/chakra-ui/issues/2347 add a null here to apply the border setting
  defaultProps: { variant: null },
};

export default NumberInput;
